import { Component, OnInit, Inject, OnDestroy, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { OrderService } from '../order.service';
import { Store } from '../models/store';
import { OrdersWithPayment, Order, Modifier, BotOrder } from '../models/order';
import { EarnedReward, earnedRewardSummary } from '../models/earned-reward';
import * as moment from 'moment';
import { Constants } from '../constants';
import { OrderHelpers } from '../order-summary/utils/helpers';
import { ArrivedDialogComponent } from '../arrived-dialog/arrived-dialog.component';
import { OrderSocketService } from '../_services/order-socket.service';
import { StoreService } from '../_services/store.service';
import { IMqttMessage, IPublishOptions, MqttService } from "ngx-mqtt";
import { IClientSubscribeOptions } from "mqtt/types/lib/client-options";
import { Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import {MatDialog} from '@angular/material/dialog';
import {MatSnackBar} from '@angular/material/snack-bar';
import {AnalyticsService} from '../_services/analytics.service';
import { DeliveryTrackingService } from './delivery-tracking/delivery-tracking.service';
import { DeliveryTrack } from './delivery-tracking/delivery-tracking.models';


@Component({
  selector: 'app-order-status',
  templateUrl: './order-status.component.html',
  styleUrls: ['./order-status.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class OrderStatusComponent implements OnInit, OnDestroy {

  tt;
  color = 'red';
  orderHash: string;
  status: string;
  orderWithPayment: OrdersWithPayment;
  store: Store;
  initial: string;
  displayedColumns: string[] = ['quantity', 'item', 'itemTotal'];
  pizzaOptions: Map<string, string> = Constants.pizzaOptions
  pizzaOptions$:Map<string, string> = Constants.pizzaOptionsFlag;
  estimatedTime: Date;

  curbsideConfirm = false;
  ends;
  submittedAt;
  uiSetting: any;
  isLoading = true;
  reorder = false;
  showReorder = false;
  isAdmin = false;
  spotData: any;
  errorMessages = {
    'Expired card': 'Expired Card: Sorry we could not process your order. The current card selected is Expired. Please change the payment type and resubmit your order.',
    'Decline': 'Decline: Sorry we could not process your order. The current card selected is being declined. Please change the payment type and resubmit your order.',
    'Invalid card': 'Invalid Card: Sorry we could not process your order. The current card selected is invalid. Please change the payment type and resubmit your order.',
    'Not sufficient funds': 'Insufficient Funds: Sorry we could not process your order. The current card selected has insufficient funds to make payments. Please change the payment type and resubmit your order.',
    'Invalid account number': 'Invalid Account Number: Sorry we could not process your order. The current card selected has an invalid card number. Please change the payment type and resubmit your order.',
    'Restricted card': 'Restricted Card: Sorry we could not process your order. The current card selected has a restricted card number. Please change the payment type and resubmit your order.',
    'Transaction not permitted to cardholder': 'Transaction not permitted the cardholder: Sorry we could not process your order. Please update or change the payment type and resubmit your order.',
    'Service not allowed': 'Service Not Allowed: Sorry we could not process your order. Please update or change the payment type and resubmit your order.',
    'Invalid transaction': 'Invalid Transaction: Sorry we could not process your order. Please update or change the payment type and resubmit your order.',
    'Wrong expiration': 'Wrong Expiration Date: Sorry we could not process your order. Please update or change the payment type and resubmit your order.',
    'Timed out': 'Timed out: Sorry we could not process your order. Please click back, wait a couple of minutes, and resubmit your order.',
    'Do not honor': 'Do not honor: Sorry we could not process your order. Please update or change the payment type and resubmit your order.',
    'Non-numeric expiry': 'Non-numeric expiry: Sorry we could not process your order. Please update or change the payment type and resubmit your order.',
    'Declined': 'Decline: Sorry we could not process your order. The current card selected is being declined. Please change the payment type and resubmit your order.',
    'Invalid issuer': 'Invalid Issuer: Sorry we could not process your order. Please update or change the payment type and resubmit your order.',
    'Invalid amount': 'Invalid Amount: Sorry we could not process your order. Please update or change the payment type and resubmit your order.',
    'Hierarchy validation': 'Hierarchy Validation: Sorry we could not process your order. Please update or change the payment type and resubmit your order.',
    'ADD AUTH REQUIRE': 'ADD AUTH REQUIRE: Sorry we could not process your order. Please update or change the payment type and resubmit your order.',
    'Invalid merchant': 'Invalid Merchant: Sorry we could not process your order. Please update or change the payment type and resubmit your order.',
    'Invalid Timezone': 'Please check our posted hours of operation and try again later. You are receiving this message because you may have your timezone settings on your device set to the incorrect timezone.',
    'Missing payment method': 'Sorry we could not process your order because the payment method could not be attached. Please select your payment method again and resubmit your order.',
    'DUPLICATE_REQUEST': 'Your payment may still be processing. Please wait a moment and check your order status before trying again. If the issue persists, contact the store directly.',
    'Unknown error': 'Sorry, we experienced a temporary issue processing your payment. Please wait a moment and try again.',
    // WORLDNET/Payroc reason texts (backend now passes responseMessage through)
    'Insufficient Funds': 'Insufficient Funds: this card does not have enough available balance for this order. Please try a different card.',
    'Expired Card': 'Expired Card: the card on this order has expired. Please try a different card.',
    'Stolen Card': 'Card Declined: the card issuer refused this card. Please try a different card.',
    'Lost Card': 'Card Declined: the card issuer refused this card. Please try a different card.',
    'Pick Up Card': 'Card Declined: the card issuer refused this card. Please try a different card.',
    'Invalid Card Number': 'Invalid Card Number: please check the card details or try a different card.',
    'temporarily unavailable': 'Our payment service is temporarily unavailable. Your card was not charged. Please wait a moment and try again.',
    'Gateway': 'Our payment service is temporarily unavailable. Your card was not charged. Please wait a moment and try again.',
  }
  /** Reasons where a different card is the fix, so "Try a different card" is the primary action. */
  cardProblemKeys = ['Insufficient', 'Expired', 'Decline', 'Stolen', 'Lost', 'Pick Up', 'Invalid card', 'Invalid Card', 'Restricted', 'Do not honor', 'Invalid account'];
  isCardProblem = false;
  isRetryable = false;
  error;

  // ENG-5668: the gateway timed out but the processor may still approve the sale. Instead of
  // "Please check payment details" + resubmit (which is how a guest gets charged twice), hold
  // the guest on a "taking longer than usual" screen and poll until the backend knows.
  static readonly PAYMENT_VERIFYING = 'payment_verifying';
  static readonly VERIFY_POLL_MS = 5000;
  static readonly VERIFY_MAX_MS = 150000;
  isVerifying = false;
  verifyingElapsed = 0;
  private verifyInterval: any;
  private verifyStartedAt = 0;
  private verifySubmitting = false;

  prgrsBar1: number;
  step1: string;
  c_color1: string;
  bar_color1: string;
  current_status1: boolean;
  prgrsBar2: number;
  step2: string;
  c_color2: string;
  bar_color2: string;
  current_status2: boolean;
  prgrsBar3: number;
  step3: string;
  c_color3: string;
  bar_color3: string;
  current_status3: boolean;
  mqtSub;
  statusinterval: any;
  earnedRewards: EarnedReward[] = [];

  // ENG-5252: customer self-serve cancellation
  cancelSecondsRemaining = 0;
  cancelTotalSeconds = 0;
  showCancelConfirm = false;
  cancelInProgress = false;
  cancelError: string;
  cancelBarReady = false;   // skip CSS transition until first value painted
  private cancelCountdownInterval: any;

  /** Delivery v2 live tracking (ENG-5514). Null means: show the classic progress bar. */
  deliveryTrack: DeliveryTrack | null = null;
  /** True while the first track request of a delivery order is still unanswered. */
  deliveryTrackPending = false;
  private deliveryTrackSub: Subscription;
  private destroySubject: Subject<void> = new Subject();
  constructor(
    private route: ActivatedRoute,
    private orderService: OrderService,
    public dialog: MatDialog,
    private router: Router,
    private orderSocketService: OrderSocketService,
    private storeService: StoreService,
    private mqttService: MqttService,
    private snackBar: MatSnackBar,
    private cdr: ChangeDetectorRef,
    private analyticsService: AnalyticsService,
    private deliveryTracking: DeliveryTrackingService,
  ) { }

  ngOnInit() {
    this.orderHash = this.route.snapshot.paramMap.get('o_hash');
    this.isAdmin = this.route.snapshot.queryParamMap.get('is_admin') === '1';
    this.status = this.route.snapshot.paramMap.get('status');
    // this.subMqtt();

    this.orderService.getOrder(this.orderHash, "0").subscribe(
      data => {
        // Null safety check for API response
        if (!data || !data.store || !data.bot_order) {
          this.isLoading = false;
          this.error = 'Unable to load order details. Please try again later.';
          return;
        }

        this.orderWithPayment = Object.assign(new OrdersWithPayment(), data, {
          bot_order: Object.assign(new BotOrder(), data.bot_order, {
            occasion_schedule: moment(data.bot_order.occasion_schedule, 'hh:mm A MMM DD, YYYY').toDate(),
            created_at: moment(data.bot_order.created_at, 'hh:mm A MMM DD, YYYY').toDate(),
            updated_at: moment(data.bot_order.updated_at, 'hh:mm A MMM DD, YYYY').toDate(),
            submitted_at: moment(data.bot_order.submitted_at, 'hh:mm A MMM DD, YYYY').toDate()
          }),
          store: Object.assign(new Store(), data.store),
          items: data.items.map(o => Object.assign(new Order(), o, {
            modifiers: o.modifiers.map(x => Object.assign(new Modifier(), x))
          })),
          payment: OrderHelpers.parsePayment(data.payment)
        });

        // Additional null check before accessing nested properties
        if (!this.orderWithPayment || !this.orderWithPayment.store || !this.orderWithPayment.store.store_name) {
          this.isLoading = false;
          this.error = 'Unable to load store details. Please try again later.';
          return;
        }

        this.initial = this.orderWithPayment.store.store_name.split(" ").map(p => p[0]).join("")
        const reason = (this.orderWithPayment.bot_order.failure_reason || '').toString();
        const lowered = reason.toLowerCase();
        const failure = Object.keys(this.errorMessages).filter(m => lowered.includes(m.toLowerCase()));
        if (failure.length <= 0) {
          this.error = reason
            ? `${reason}. Sorry, we could not process your order. Please update or change the payment type and resubmit your order.`
            : 'Sorry, we could not process your order. Please update or change the payment type and resubmit your order.';
        } else {
          this.error = this.errorMessages[failure[0]];
        }
        this.isCardProblem = this.cardProblemKeys.some(k => lowered.includes(k.toLowerCase()));
        this.isRetryable = lowered.includes('unavailable') || lowered.includes('timed out') || lowered.includes('gateway') || lowered.includes('unknown error');
        if (this.status === 'failure' && this.orderWithPayment.bot_order.is_submitted && !this.orderWithPayment.bot_order.is_payment_pending) {
          // Payment was confirmed meanwhile (poll in another tab, or the guest came back later):
          // the order is placed, so the failure page is wrong — show the receipt.
          this.router.navigate(['order', this.orderHash, 'status', 'success'], { replaceUrl: true });
          return;
        }
        if (this.status === 'failure' && lowered === OrderStatusComponent.PAYMENT_VERIFYING) {
          this.startPaymentVerification();
        }
        this.uiSetting = this.orderWithPayment.store.ui_settings;
        this.isLoading = false;

        this.storeService.changeStore(this.orderWithPayment.store);
        this.analyticsService.setStore(this.orderWithPayment.bot_order.store, this.orderWithPayment.store.store_name);
        if (this.orderWithPayment.bot_order.phone_number) {
          this.analyticsService.identifyUser(null, this.orderWithPayment.bot_order.phone_number);
        }
        if (this.status === 'success' && !this.orderWithPayment.bot_order.is_cancelled) {
          this.analyticsService.trackEventOnce('purchase', this.orderHash, {
            transaction_id: this.orderHash,
            order_hash: this.orderHash,
            value: this.orderWithPayment.payment.total,
            item_count: this.orderWithPayment.items.length,
            store_id: this.orderWithPayment.bot_order.store,
            store_name: this.orderWithPayment.store.store_name,
            occasion: this.orderWithPayment.bot_order.occasion,
            payment_type: this.orderWithPayment.bot_order.payment_type
          });
        } else if (this.status === 'failure') {
          this.analyticsService.trackEventOnce('payment_failed', this.orderHash, {
            order_hash: this.orderHash,
            store_id: this.orderWithPayment.bot_order.store,
            failure_reason: this.orderWithPayment.bot_order.failure_reason
          });
        }
        this.orderTrackingStatus(this.orderWithPayment);
        this.syncCancelWindow();
        this.loadEarnedRewards();
        this.startDeliveryTracking();
        this.route.queryParams.pipe(takeUntil(this.destroySubject)).subscribe(params => {
          // Reorder is offered whenever the store allows it. Pre-checking the menu only ever
          // produced a dead end ("not available due to menu update") on orders the backend would
          // have copied fine; it now copies what is still on the menu and names what it dropped.
          if ('reorder' in params) {
            this.showReorder = true
            this.reorder = this.orderWithPayment.store.isEnabled('reorder')
          }
        })
        this.cdr.markForCheck();

      },
    err => {
      this.isLoading = false;
      this.error = 'Unable to load order details. Please try again later.';
    });

    if (this.status == "success") {
      this.statusinterval = setInterval(() => {
        this.getOrderStatus();
      }, 30000);
    }
  }

  goBack() {
    window.history.back()
  }

  /** ENG-5668: poll payment_status until the backend confirms, fails, or we give up. */
  startPaymentVerification() {
    this.isVerifying = true;
    this.verifyingElapsed = 0;
    this.verifyStartedAt = Date.now();
    this.stopPaymentVerification(false);
    this.checkPaymentStatus();
    this.verifyInterval = setInterval(() => this.checkPaymentStatus(), OrderStatusComponent.VERIFY_POLL_MS);
    this.cdr.markForCheck();
  }

  stopPaymentVerification(leaveVerifying = true) {
    if (this.verifyInterval) {
      clearInterval(this.verifyInterval);
      this.verifyInterval = null;
    }
    if (!leaveVerifying) {
      return;
    }
    this.isVerifying = false;
    this.cdr.markForCheck();
  }

  private checkPaymentStatus() {
    if (this.verifySubmitting) {
      return;
    }
    this.verifyingElapsed = Math.round((Date.now() - this.verifyStartedAt) / 1000);
    this.cdr.markForCheck();
    if (Date.now() - this.verifyStartedAt > OrderStatusComponent.VERIFY_MAX_MS) {
      this.showVerificationFailed('Payment service is temporarily unavailable. Please try again in a moment.');
      return;
    }
    this.orderService.getPaymentStatus(this.orderHash).pipe(takeUntil(this.destroySubject)).subscribe(
      (res) => {
        switch (res?.status) {
          case 'paid':
            this.stopPaymentVerification();
            this.router.navigate(['order', this.orderHash, 'status', 'success']);
            break;
          case 'confirmed':
            // The processor approved the sale and the backend has recorded it; one submit now
            // completes the order through the normal path (receipt, kitchen, SMS).
            this.completeVerifiedOrder();
            break;
          case 'failed':
          case 'none':
            this.showVerificationFailed(res.failure_reason);
            break;
          default:
            // 'verifying' — keep waiting.
            break;
        }
      },
      () => {
        // A transient error on the poll itself is not an answer; keep polling until VERIFY_MAX_MS.
      }
    );
  }

  private completeVerifiedOrder() {
    if (this.verifySubmitting) {
      return;
    }
    this.verifySubmitting = true;
    this.stopPaymentVerification(false);
    const isFuture = !!this.orderWithPayment?.bot_order?.is_future_order;
    this.orderService.submitOrder(this.orderHash, true, isFuture).pipe(takeUntil(this.destroySubject)).subscribe(
      () => {
        this.verifySubmitting = false;
        this.stopPaymentVerification();
        this.analyticsService.trackEventOnce('payment_recovered', this.orderHash, { order_hash: this.orderHash });
        this.router.navigate(['order', this.orderHash, 'status', 'success']);
      },
      (error) => {
        this.verifySubmitting = false;
        this.analyticsService.captureException(error, { step: 'complete_verified_order', order_hash: this.orderHash });
        this.showVerificationFailed(error?.error?.failure_reason || 'Payment service is temporarily unavailable. Please try again in a moment.');
      }
    );
  }

  private showVerificationFailed(reason: string | null) {
    this.stopPaymentVerification(false);
    this.isVerifying = false;
    const text = (reason || '').toString();
    const lowered = text.toLowerCase();
    const failure = Object.keys(this.errorMessages).filter(m => lowered.includes(m.toLowerCase()));
    this.error = failure.length > 0
      ? this.errorMessages[failure[0]]
      : (text && lowered !== OrderStatusComponent.PAYMENT_VERIFYING
        ? `${text}. Sorry, we could not process your order. Please update or change the payment type and resubmit your order.`
        : 'Sorry, we experienced a temporary issue processing your payment. Please wait a moment and try again.');
    this.isCardProblem = this.cardProblemKeys.some(k => lowered.includes(k.toLowerCase()));
    this.isRetryable = !this.isCardProblem;
    this.cdr.markForCheck();
  }

  /** Back to checkout with the wallet open, so the fix for a declined card is one tap away. */
  retryWithDifferentCard() {
    const hash = this.orderWithPayment?.bot_order?.order_hash || this.orderHash;
    this.router.navigate(['order', hash], { queryParams: { openWallet: 1 } });
  }

  backToOrder() {
    const hash = this.orderWithPayment?.bot_order?.order_hash || this.orderHash;
    this.router.navigate(['order', hash]);
  }

  loadEarnedRewards() {
    const userHash = this.orderWithPayment && this.orderWithPayment.bot_order
      && this.orderWithPayment.bot_order.encoded_id;
    const storeId = this.orderWithPayment && this.orderWithPayment.bot_order
      && this.orderWithPayment.bot_order.store;
    if (!userHash || !storeId || this.orderWithPayment.bot_order.is_cancelled) {
      return;
    }
    this.orderService.getMyRewards(String(storeId), userHash).subscribe({
      next: (data) => {
        this.earnedRewards = ((data && data.active) || []).filter(r =>
          r.status === 'ACTIVE' &&
          r.earned_from_order_hash === this.orderWithPayment.bot_order.order_hash);
        this.cdr.markForCheck();
      },
      error: () => { }
    });
  }

  getRewardSummary(reward: EarnedReward) {
    return earnedRewardSummary(reward);
  }

  /**
   * Live tracking for in-house delivery orders. Any other occasion never calls the
   * endpoint, and when it 404s or fails the page stays exactly as it was before.
   */
  private startDeliveryTracking() {
    const order = this.orderWithPayment && this.orderWithPayment.bot_order;
    if (this.deliveryTrackSub || this.status !== 'success' || !order) {
      return;
    }
    // Third-party couriers keep their own tracking inside <app-order-progress>.
    if (order.occasion !== 'DELIVERY' || order.is_cancelled || order.delivery_status_doordash) {
      return;
    }
    this.deliveryTrackPending = true;
    const settle = () => {
      if (this.deliveryTrackPending) {
        this.deliveryTrackPending = false;
        this.cdr.markForCheck();
      }
    };
    this.deliveryTrackSub = this.deliveryTracking.watch(this.orderHash)
      .pipe(takeUntil(this.destroySubject))
      .subscribe({
        next: track => {
          this.deliveryTrack = track;
          this.deliveryTrackPending = false;
          this.cdr.markForCheck();
        },
        error: () => {
          this.deliveryTrack = null;
          settle();
        },
        complete: settle
      });
  }

  informStore(): void {

    const dialogRef = this.dialog.open(ArrivedDialogComponent, {
      width: '350px',
      disableClose: true,
      data: {
        confirmText: 'I\'m here',
        message: 'Please make sure you are parked in a designated, legal, safe place.',
        parking: 1,
        spot_field: this.orderWithPayment.store.is_spot_field_mandatory
      }
    });

    dialogRef.afterClosed().subscribe(data => {
      this.isLoading = true;
      if (data == true) {
        if (this.orderWithPayment.store.is_spot_field_mandatory) {
          this.spotData = dialogRef.componentInstance.form.get('name').value;
        } else {
          this.spotData = '';
        }
        this.orderService.curbsideConfirm(this.orderHash, this.spotData).subscribe(data => {
          this.orderWithPayment.bot_order.curbside_drop_off = true;
          this.isLoading = false;
        },
          (error) => {
            if (error.status == 400) {
              this.isLoading = false;
              this.orderWithPayment.bot_order.curbside_drop_off = true;
            }
          });
      } else {
        this.isLoading = false;
      }
    });
  }

  reOrder() {
    this.orderService.reOrder(this.orderHash).subscribe(response => {
      // Nothing survived the copy: an empty cart would look like the button was broken.
      if (response?.copied_items === 0) {
        this.snackBar.open('None of these items are still on the menu.', 'OK', { duration: 5000 });
        return;
      }
      // The backend copies what it can and reports what it dropped; staying quiet would let a
      // shopper check out believing an item is in the bag when it is not.
      const skipped = (response?.skipped_items || []).map(s => s?.item).filter(Boolean);
      if (skipped.length) {
        this.snackBar.open(
          `${skipped.join(', ')} ${skipped.length === 1 ? 'is' : 'are'} no longer available and ${skipped.length === 1 ? 'was' : 'were'} left out.`,
          'OK', { duration: 6000 });
      }
      this.router.navigate(['order', response.order_hash])
    });
  }

  orderTrackingStatus(order) {
    if (order) {
      if (order.bot_order.is_cancelled) {
        this.prgrsBar1 = 100;
        this.step1 = 'Declined';
        this.c_color1 = 'red';
        this.bar_color1 = 'red';
        this.current_status1 = false;

        this.prgrsBar2 = 100;
        this.step2 = 'Preparing';
        this.c_color2 = 'grey';
        this.bar_color2 = 'grey';
        this.current_status2 = false;

        this.prgrsBar3 = 100;
        this.step3 = 'Ready!';
        this.c_color3 = 'grey';
        this.bar_color3 = 'grey';
        this.current_status3 = false;

        clearInterval(this.statusinterval);
      } else {
        if (!order.bot_order.view_notified && !order.bot_order.ready_notified) {
          this.prgrsBar1 = 100;
          this.step1 = 'Submitting';
          this.c_color1 = 'orange';
          this.bar_color1 = 'grey';
          this.current_status1 = true;

          this.prgrsBar2 = 100;
          this.step2 = 'Preparing';
          this.c_color2 = 'grey';
          this.bar_color2 = 'grey';
          this.current_status2 = false;

          this.prgrsBar3 = 0;
          this.step3 = 'Ready!';
          this.c_color3 = 'grey';
          this.bar_color3 = 'grey';
          this.current_status3 = false;
        }
        else if (order.bot_order.view_notified && !order.bot_order.ready_notified) {
          this.prgrsBar1 = 100;
          this.step1 = 'Received';
          this.c_color1 = 'green';
          this.bar_color1 = 'green';
          this.current_status1 = false;

          this.prgrsBar2 = 100;
          this.step2 = 'Preparing';
          this.c_color2 = 'orange';
          this.bar_color2 = 'grey';
          this.current_status2 = true;

          this.prgrsBar3 = 0;
          this.step3 = 'Ready!';
          this.c_color3 = 'grey';
          this.bar_color3 = 'grey';
          this.current_status3 = false;
        }
        else if (order.bot_order.view_notified && order.bot_order.ready_notified) {
          this.prgrsBar1 = 100;
          this.step1 = 'Received';
          this.c_color1 = 'green';
          this.bar_color1 = 'green';
          this.current_status1 = false;

          this.prgrsBar2 = 100;
          this.step2 = 'Preparing';
          this.c_color2 = 'green';
          this.bar_color2 = 'green';
          this.current_status2 = false;

          this.prgrsBar3 = 100;
          this.step3 = 'Ready!';
          this.c_color3 = 'green';
          this.bar_color3 = 'green';
          this.current_status3 = false;

          clearInterval(this.statusinterval);
        }
      }
      this.tt = [
        {

          "percent": this.prgrsBar1,
          "name": this.step1,
          "color": this.c_color1,
          "bar_color": this.bar_color1,
          "current_status": this.current_status1
        },
        {

          "percent": this.prgrsBar2,
          "name": this.step2,
          "color": this.c_color2,
          "bar_color": this.bar_color2,
          "current_status": this.current_status2

        },
        {

          "percent": this.prgrsBar3,
          "name": this.step3,
          "color": this.c_color3,
          "bar_color": this.bar_color3,
          "current_status": this.current_status3
        }
      ]
    }
  }

  subMqtt() {
    let currentStoreId = localStorage.getItem("currentStore")
    this.mqtSub = this.mqttService.observe(`/order_status/${currentStoreId}/sub`,
      { qos: 1 } as IClientSubscribeOptions).subscribe((message: IMqttMessage) => {
        const response = JSON.parse(message.payload.toString());
        if (response) {
          if (this.orderWithPayment.bot_order.id == response.bot_order.id) {
            this.orderWithPayment = Object.assign(new OrdersWithPayment(), response, {
              bot_order: Object.assign(new BotOrder(), response.bot_order, {
                occasion_schedule: moment(response.bot_order.occasion_schedule, 'hh:mm A MMM DD, YYYY').toDate(),
                created_at: moment(response.bot_order.created_at, 'hh:mm A MMM DD, YYYY').toDate(),
                updated_at: moment(response.bot_order.updated_at, 'hh:mm A MMM DD, YYYY').toDate(),
                submitted_at: moment(response.bot_order.submitted_at, 'hh:mm A MMM DD, YYYY').toDate()
              }),
              store: Object.assign(new Store(), response.store),
              items: response.items.map(o => Object.assign(new Order(), o, {
                modifiers: o.modifiers.map(x => Object.assign(new Modifier(), x))
              })),
              payment: OrderHelpers.parsePayment(response.payment)
            });
            this.orderTrackingStatus(response);
          }
        }
      });
  }

  getOrderStatus() {
    this.orderService.getOrder(this.orderHash, "0").pipe(takeUntil(this.destroySubject)).subscribe((response: any) => {
      if (this.orderWithPayment.bot_order.id == response.bot_order.id) {
        this.orderWithPayment = Object.assign(new OrdersWithPayment(), response, {
          bot_order: Object.assign(new BotOrder(), response.bot_order, {
            occasion_schedule: moment(response.bot_order.occasion_schedule, 'hh:mm A MMM DD, YYYY').toDate(),
            created_at: moment(response.bot_order.created_at, 'hh:mm A MMM DD, YYYY').toDate(),
            updated_at: moment(response.bot_order.updated_at, 'hh:mm A MMM DD, YYYY').toDate(),
            submitted_at: moment(response.bot_order.submitted_at, 'hh:mm A MMM DD, YYYY').toDate()
          }),
          store: Object.assign(new Store(), response.store),
          items: response.items.map(o => Object.assign(new Order(), o, {
            modifiers: o.modifiers.map(x => Object.assign(new Modifier(), x))
          })),
          payment: OrderHelpers.parsePayment(response.payment)
        });
        this.orderTrackingStatus(response);
        this.syncCancelWindow();
        this.cdr.markForCheck();
      }
    });
  }

  durationAsString(start, end) {
    const duration = moment.duration(moment(end).diff(moment(start)));

    //Get Days
    const days = Math.floor(duration.asDays()); // .asDays returns float but we are interested in full days only
    const daysFormatted = days ? `${days} days, ` : ''; // if no full days then do not display it at all

    //Get Hours
    const hours = duration.hours();
    const hoursFormatted = `${hours} hrs, `;

    //Get Minutes
    const minutes = duration.minutes();
    const minutesFormatted = `${minutes} minutes`;

    return [daysFormatted, hoursFormatted, minutesFormatted].join('');
  }

  // ENG-5252: re-derive the cancel window from server-computed eligibility on
  // every load/poll (never from local arrival time — the page is reachable
  // long after placement via order history).
  private syncCancelWindow() {
    const botOrder: any = this.orderWithPayment && this.orderWithPayment.bot_order;
    if (this.cancelCountdownInterval) {
      clearInterval(this.cancelCountdownInterval);
      this.cancelCountdownInterval = null;
    }
    if (!botOrder || !botOrder.can_customer_cancel || botOrder.is_cancelled) {
      this.cancelSecondsRemaining = 0;
      return;
    }
    // Disable CSS transition so the bar paints at the correct starting
    // width instantly (prevents the 0% → current% "fill-up" animation
    // that happens on every page load / refresh).
    this.cancelBarReady = false;
    this.cancelSecondsRemaining = botOrder.customer_cancel_seconds_remaining || 0;
    this.cancelTotalSeconds = botOrder.customer_cancel_window_seconds || this.cancelSecondsRemaining;
    // After one change-detection pass has painted the bar at its real
    // width, re-enable transitions so the 1-second tick-downs animate.
    setTimeout(() => {
      this.cancelBarReady = true;
      this.cdr.markForCheck();
    }, 50);
    // Tick down the 60s window for standard orders; future orders have an
    // hours-long window, so a visible countdown is meaningless there.
    if (!this.isFutureOrder() && this.cancelSecondsRemaining > 0) {
      this.cancelCountdownInterval = setInterval(() => {
        this.cancelSecondsRemaining--;
        if (this.cancelSecondsRemaining <= 0) {
          this.cancelSecondsRemaining = 0;
          this.showCancelConfirm = false;
          clearInterval(this.cancelCountdownInterval);
          this.cancelCountdownInterval = null;
        }
        this.cdr.markForCheck();
      }, 1000);
    }
  }

  get cancelTimeDisplay(): string {
    const s = this.cancelSecondsRemaining;
    if (s <= 0) return '0s';
    const m = Math.floor(s / 60);
    const sec = s % 60;
    if (m > 0 && sec > 0) return `${m}m ${sec}s`;
    if (m > 0) return `${m}m`;
    return `${sec}s`;
  }

  get cancelProgressPercent(): number {
    if (!this.cancelTotalSeconds || this.cancelTotalSeconds <= 0) return 0;
    return Math.max(0, Math.min(100,
      (this.cancelSecondsRemaining / this.cancelTotalSeconds) * 100));
  }

  isFutureOrder(): boolean {
    const botOrder: any = this.orderWithPayment && this.orderWithPayment.bot_order;
    return !!botOrder && (botOrder.is_future_order || botOrder.time == 'LATER');
  }

  canCancelOrder(): boolean {
    const botOrder: any = this.orderWithPayment && this.orderWithPayment.bot_order;
    return !!botOrder && botOrder.can_customer_cancel && !botOrder.is_cancelled
      && this.cancelSecondsRemaining > 0;
  }

  // ENG-5252: the server computes the deadline (post-placement window, capped
  // at the scheduled time) — phrase the hint from whatever time remains.
  futureCancelHintText(): string {
    const secs = this.cancelSecondsRemaining;
    if (secs > 2 * 3600) {
      const hours = Math.floor(secs / 3600);
      return `You can cancel this order for the next ${hours} hours.`;
    }
    const mins = Math.max(1, Math.floor(secs / 60));
    return `You can cancel this order for the next ${mins} minute${mins === 1 ? '' : 's'}.`;
  }

  isCancelledByMe(): boolean {
    const botOrder: any = this.orderWithPayment && this.orderWithPayment.bot_order;
    return !!botOrder && botOrder.is_cancelled && botOrder.cancelled_by == 'CUSTOMER';
  }

  confirmCancel() {
    this.cancelError = null;
    this.showCancelConfirm = true;
  }

  dismissCancel() {
    this.showCancelConfirm = false;
  }

  cancelOrder() {
    if (this.cancelInProgress) {
      return;
    }
    this.cancelInProgress = true;
    this.cancelError = null;
    this.orderService.cancelOrder(this.orderHash).subscribe(() => {
      this.analyticsService.trackEvent('order_cancelled', {
        order_hash: this.orderHash,
        order_total: this.orderWithPayment.payment.total,
        store_id: this.orderWithPayment.bot_order.store
      });
      this.cancelInProgress = false;
      this.showCancelConfirm = false;
      this.cancelSecondsRemaining = 0;
      if (this.cancelCountdownInterval) {
        clearInterval(this.cancelCountdownInterval);
        this.cancelCountdownInterval = null;
      }
      this.getOrderStatus();
      this.cdr.markForCheck();
    }, (error) => {
      this.cancelInProgress = false;
      this.cancelError = (error && error.error && error.error.detail)
        || 'We could not cancel your order. Please contact the restaurant directly.';
      // A rejection means eligibility changed server-side — resync via poll.
      this.getOrderStatus();
      this.cdr.markForCheck();
    });
  }

  calculateTimeDifference(submitted_at: string, occasion_schedule: string): string {
    const submittedDate = new Date(submitted_at);
    const occasionDate = new Date(occasion_schedule);
    const diffMs = occasionDate.getTime() - submittedDate.getTime();
    // If time has passed, return "0 min"
    if (diffMs <= 0) {
      return "0 min";
    }
    // Convert to total minutes
    const totalMinutes = Math.floor(diffMs / (1000 * 60));
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;
    // Build formatted string
    let parts: string[] = [];
    if (hours > 0) {
      parts.push(`${hours} hr${hours > 1 ? 's' : ''}`);
    }
    if (minutes > 0) {
      parts.push(`${minutes} min${minutes > 1 ? 's' : ''}`);
    }
    return parts.length > 1
      ? parts.slice(0, -1).join(', ') + ' and ' + parts[parts.length - 1]
      : parts[0];
  }

  ngOnDestroy() {
    if (this.mqtSub) {
      this.mqtSub.unsubscribe();
    }
    if (this.verifyInterval) {
      clearInterval(this.verifyInterval);
    }
    if (this.statusinterval) {
      clearInterval(this.statusinterval);
    }
    if (this.cancelCountdownInterval) {
      clearInterval(this.cancelCountdownInterval);
    }
    if (this.deliveryTrackSub) {
      this.deliveryTrackSub.unsubscribe();
    }
    this.destroySubject.next();
  }

}
